const actions = {
  getUsuarios: async (
    context,
    {
      vendor_id,
      page,
      per_page,
      search,
      biometria,
      cost_center_id,
      ghe,
      cargo,
      status,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`auth/users`, {
      params: {
        vendor_id,
        page,
        per_page,
        search,
        biometria,
        cost_center_id,
        ghe,
        cargo,
        status,
      },
    });

    return response;
  },
  getUsuariosAfastados: async (
    context,
    { vendor_id, page, per_page, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`auth/users`, {
      params: {
        vendor_id,
        page,
        per_page,
        status: "Afastado",
        search,
      },
    });

    return response;
  },
  getUsuariosDesligados: async (
    context,
    { vendor_id, page, per_page, search, status = "Desligado" }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/users/reports/master-data-v2`, {
      params: {
        vendor_id,
        page,
        per_page,
        desligado: 1,
        user: search,
        status,
      },
    });

    return response;
  },
  reativarUsuarioDesligado: async (context, { user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user_id}/restore`);

    return response;
  },
  desligarUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`auth/users/${id}`);

    return response;
  },
  afastarUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`auth/users/${id}/change-status`, {
      user_id: id,
      status: "Afastado",
    });

    return response;
  },
  reativarUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`auth/users/${id}/change-status`, {
      user_id: id,
      status: "Ativo",
    });

    return response;
  },
  criarUsuario: async (
    context,
    { email, name, sap, cost_center_id, function_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`auth/users`, {
      admission_date: "01/01/2001",
      email,
      cost_center_id,
      name,
      sap,
      function_id,
    });

    return response;
  },

  criarUsuarioTemplate: async (context, { planilha, vendor }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/manutencao-planilha`, {
      mapeamento: "usuario",
      planilha,

      adicional: { vendor_id: vendor },
    });

    return response;
  },

  getUserEspecifico: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/users/${id}`);

    return response;
  },

  vincularUnidade: async (context, { id, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`auth/users/${id}/vendors/${vendor_id}`);

    return response;
  },

  getRoles: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/authorization/roles`, {
      params: {
        per_page: 1000,
      },
    });

    return response;
  },

  getFuncoes: async (context, { vendor_id, search, page, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/functions`, {
      params: {
        vendor_id,
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  getCentros: async (context, { vendor_id, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/cost-centers`, {
      params: {
        vendor_id,
        per_page,
        search,
        page,
      },
    });

    return response;
  },

  getTurnos: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendor-shifts`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  editarUser: async (
    context,
    { user, vendor_shift_id, roles, cost_center_id, function_id, email }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    if (function_id) {
      const response = await api.put(`/auth/users/${user.id}`, {
        user_id: user.id,
        name: user.name,
        tnumber: user.tnumber,
        sap: user.sap,
        admission_date: user.admission_date,
        cargo: user.cargo,
        vendor_shift_id,
        role_id: roles,
        cost_center_id,
        function_id,
        email,
      });

      return response;
    } else {
      const response = await api.put(`/auth/users/${user.id}`, {
        user_id: user.id,
        name: user.name,
        tnumber: user.tnumber,
        sap: user.sap,
        admission_date: user.admission_date,
        cargo: user.cargo,
        vendor_shift_id,
        role_id: roles,
        cost_center_id,
        email,
      });

      return response;
    }
  },

  editarRoles: async (context, { user, roles }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user.id}/roles/${roles}`);
    return response;
  },

  atribuirPerfil: async (context, { user_id, role_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user_id}/roles/${role_id}`);
    return response;
  },

  removerPerfil: async (context, { user_id, roles }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user_id}/detach-roles`, {
      roles,
    });

    return response;
  },

  getCards: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/cards`, {
      params: {
        user_id: id,
      },
    });
    return response;
  },

  setCards: async (context, { card_id, password, user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/auth/cards`, {
      card_id,
      password,
      user_id,
    });
    return response;
  },

  atualizarCards: async (
    context,
    { card_id, card_index, user_id, password }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/cards/${card_index}`, {
      card_id,
      card_index,
      user_id,
      password,
    });
    return response;
  },

  deletarCards: async (context, { card_index }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/auth/cards/${card_index}`);

    return response;
  },

  deletarCentro: async (context, { id, center_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/auth/users/${id}/cost-centers/${center_id}`
    );

    return response;
  },

  adicionarAprovadorRequisitante: async (context, { id, cost_centers }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/cost-centers`, {
      user_id: id,

      cost_centers,
    });

    return response;
  },

  vizualizarFinalizarUnidades: async (context, { id, finish, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/vendors/${vendor_id}`, {
      user_id: id,
      finish,

      vendor_id,
    });

    return response;
  },

  getUnidades: async (context, { per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/users?per_page=50`, {
      params: {
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  removerUnidade: async (context, { id, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/auth/users/${id}/vendors/${vendor_id}`);

    return response;
  },

  getProdutosGrupos: async (context, { id, page, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups/report`, {
      params: {
        per_page,
        page,
        product_group: search,
        user_id: id,
        control_types: "all",
      },
    });

    return response;
  },

  removerGrupo: async (context, { id, group_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/product-groups/${group_id}/users/${id}`
    );

    return response;
  },

  getTreinamentos: async (context, { page, per_page, treinamento }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/treinamento/funcionario/treinamentos-realizados`,
      {
        params: {
          page,
          per_page,
          treinamento,
        },
      }
    );

    return response;
  },

  getTreinamentosAssociados: async (context, { id, nomeTreinamento }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/treinamento/funcionario/encontrar-id`, {
      params: {
        funcionarioId: id,
        nomeTreinamento,
      },
    });

    return response;
  },

  getFerramentas: async (context, { id, nome_ferramenta }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/ferramentas/listar-ferramentas/liberadas-por-funcionario`,
      {
        params: {
          user_id: id,
          nome_ferramenta,
        },
      }
    );

    return response;
  },

  removerFerramenta: async (context, { id, ferramenta_uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/ferramentas/${ferramenta_uuid}/desvincular-usuario/${id}`,
      {
        params: {
          user_id: id,
          uuid_tool: ferramenta_uuid,
        },
      }
    );

    return response;
  },

  listarPins: async (context, { page, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/cards/listagem-troca-pin`, {
      params: {
        page,
        per_page,
      },
    });

    return response;
  },
  setLiderado: async (context, { liderado, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${liderado}/lider/${id}`);

    return response;
  },
  setLider: async (context, { lider, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/lider/${lider}`);

    return response;
  },
  desvincularLider: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/desvincular-lider`);

    return response;
  },
  excluirUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/desvincular-lider`);

    return response;
  },
  liberarPrazo: async (context, { user_id, group_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/product-groups/${group_id}/temporary-withdrawal`,
      {
        user_id,
      }
    );

    return response;
  },
  exportarPins: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/cards/listagem-troca-pin`, {
      params: {
        download: "xlsx",
      },
    });

    return response;
  },

  atualizarTemplatesBiometria: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users/refresh-biometry`);

    return response;
  },

  atualizarTemplatesFacial: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users/refresh-facial`);

    return response;
  },

  // Editar Usuario
  removerGheUsuario: async (context, { userId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`auth/users/${userId}/remover-ghe`);

    return response;
  },

  adicionarRegraGrupo: async (
    context,
    {
      group_id,
      user_id,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      critico,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${group_id}/users`, {
      user_id,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id,
      critico,
    });

    return response;
  },

  getGrupoAssosiados: async (context, { user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/product-groups/report`, {
      params: {
        control_types: "all",
        per_page: 100,
        user_id,
      },
    });

    return response;
  },

  produtosGrupo: async (context, { unidade, group_id, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/contracts/${unidade}`, {
      params: {
        group_id,
        search,
      },
    });

    return response;
  },

  indexarRegras: async (context, { usuarios }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/regra/reindexar-usuarios`, {
      usuarios,
    });

    return response;
  },

  deletarEpiGrupo: async (context, { epi_id, grupo_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(
      `/product-groups/${grupo_id}/users/${epi_id}`
    );

    return response;
  },

  getProdutos: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups/${id}`, {
      params: {
        per_page: 1000,
      },
    });

    return response;
  },

  cadastrarFacial: async (context, { usuarioId, biometria }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/biometria`, {
      usuarioId,
      biometria,
      liveness_check: 1,
    });

    return response;
  },

  criarRegraExecutor: async (
    context,
    { usuarioId, vendorId, resource, acao }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`authorization/resource`, {
      usuarioId,
      vendorId,
      resource,
      acao,
    });

    return response;
  },

  getRegraExecutor: async (
    context,
    { usuarioId, vendorId, resource, acao, perPage, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`authorization/resource`, {
      params: {
        usuarioId,
        vendorId,
        resource,
        acao,
        perPage,
        page,
      },
    });

    return response;
  },
  getBiometriaCadastrada: async (context, { user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/biometria`, {
      params: {
        user_id,
      },
    });

    return response;
  },
  assinarBiometriaCadastrada: async (context, { image_url }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/biometria/assinar`, {
      image_url,
    });

    return response;
  },
  deletarImagem: async (context, { userId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/biometria/${userId}`);

    return response;
  },

  deletarRegraExecutor: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`authorization/resource/${id}`);

    return response;
  },

  assinarTermo: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/aceite-biometria-com-log`, {
      usuarios: [
        {
          id: id,
          observacao:
            "https://multpex-docs.s3.amazonaws.com/termos-e-documentos/vale-epiexpress/Termo+de+Responsabilidade+e+Aviso+Privacidade+-+2022-09-06.pdf?#zoom=170",
        },
      ],
    });

    return response;
  },
};

export const user = {
  namespaced: true,
  actions,
};
